import { render } from "./rulemanag.vue?vue&type=template&id=5da117be&scoped=true"
import script from "./rulemanag.vue?vue&type=script&lang=js"
export * from "./rulemanag.vue?vue&type=script&lang=js"

import exportComponent from "/opt/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5da117be"]])

export default __exports__